export default {
  settings: {},
  defaultSettings: {
    enabled: false,
    message: 'This site uses cookies.',
    barSize: 'full-width', // small || full-width
    horizontalPosition: 'left', // left || right
    buttonText: 'Accept',
    preview: false
  }
}
